<template>
  <div class="home-footer is-hidden">
    <div class="home-footer__container">
      <artwork ref="artwork" :prefix="`${plant.id}_${plant.title}`" :oeuvre="plant.content.oeuvre" v-if="plant"></artwork>
      <ui-footer></ui-footer>
    </div>
  </div>
</template>

<script>
import 'styles/components/home-footer.styl'
import Detector from 'utils/Detector'
import Emitter from 'core/Emitter'

import UiFooter from 'components/UI/Footer.vue'
import Artwork from 'components/Artwork/index.vue'

export default {
  name: 'home-footer',
  data () {
    return {
      plant: null
    }
  },

  components: {
    Artwork,
    UiFooter
  },

  created () {
  },

  mounted () {
    this.container = this.$el.querySelector('.home-footer__container')

    this.bindAll()

    this.addListeners()

    this.$nextTick(() => {
      this.init()
    })
  },
  beforeDestroy () {
    this.removeListeners()
  },

  methods: {
    addListeners () {
      Emitter.on('TICK', this.update)
      Emitter.on('RESIZE', this.resize)
    },

    removeListeners () {
      Emitter.removeListener('TICK', this.update)
      Emitter.removeListener('RESIZE', this.resize)
    },

    init () {
      this.plant = this.$parent.$parent.flowersData[0]
    },

    bindAll () {
      ['update', 'resize']
          .forEach((fn) => (this[fn] = this[fn].bind(this)))
    },

    resize ({size}) {
    },

    update ({scrollVars, globalTime}) {
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** footer-home.vue?673a7441
 **/